"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionSummary = exports.AccordionDetails = exports.AccordionComponent = void 0;
var _mui = require("@ori-ui/mui");
const AccordionComponent = exports.AccordionComponent = (0, _mui.styled)(_mui.Accordion)(({
  theme
}) => ({
  borderTop: `1px solid ${theme.palette.grey[100]}`,
  boxShadow: 'none',
  '&:first-of-type, &:last-of-type': {
    borderRadius: 0
  },
  '&:last-of-type': {
    borderBottom: `1px solid ${theme.palette.grey[100]}`
  },
  '&::before': {
    display: 'none'
  },
  [`&.${_mui.accordionClasses.expanded}`]: {
    margin: 0
  }
}));
const AccordionSummary = exports.AccordionSummary = (0, _mui.styled)(_mui.AccordionSummary)(({
  theme
}) => ({
  minHeight: 'unset',
  padding: theme.spacing(3, 0),
  [`& > .${_mui.accordionSummaryClasses.content}`]: {
    margin: 0,
    [`&.${_mui.accordionSummaryClasses.expanded}`]: {
      margin: 0
    }
  },
  [`&.${_mui.accordionSummaryClasses.expanded}`]: {
    minHeight: 'unset'
  },
  [`& > .${_mui.accordionSummaryClasses.expandIconWrapper}`]: {
    color: theme.palette.text.primary
  },
  '&:hover': {
    color: theme.palette.text.hover,
    [`& > .${_mui.accordionSummaryClasses.expandIconWrapper}`]: {
      color: theme.palette.text.hover
    }
  }
}));
const AccordionDetails = exports.AccordionDetails = (0, _mui.styled)(_mui.AccordionDetails)(({
  theme
}) => ({
  padding: theme.spacing(0, 0, 3, 0)
}));
